module.exports = __webpack_public_path__ + "static/Syberia6-eef51c41d84cd1024aa54e8e2997b3e3.png";